import { NgModule } from '@angular/core';
import { ReplacePipe } from './replace';
import { HighlightPipe } from './highlight.pipe';

@NgModule({
  imports: [],
  declarations: [
    HighlightPipe,
    ReplacePipe,
  ],
  exports: [
    HighlightPipe,
    ReplacePipe,
  ]
})

export class PipesModule {
}
